<app-terminal-overlay
    [title]="title()"
    subtitle="{{ 'GENERAL.SUBTITLE.SELECT_LOCATION' | translate }}"
    icon="fa-location-dot"
    [activityType]="activity()?.activityType"
    data-test="location-selection-page"
    (closeRequested)="onCloseRequested()"
>
    <priva-filter-search
        header
        [config]="filterSearchConfig"
        [dataSource]="locationDataSource"
        class="location-filter__search"
        data-test="search-location-bar"
    />

    <div class="location-selector__overview">
        @if (locationList.length) {
            <priva-table
                class="location-table"
                [rows]="locationList"
                [disableSelect]="true"
                type="separate"
                [hasHeader]="false"
                (rowClick)="onTableRowClick($event)"
                data-test="location-list-table"
            >
                <ng-template priva-table-column="Name" let-item="row"> {{ item.name }}</ng-template>
            </priva-table>
        } @else {
            <priva-notification>{{ 'ERROR.TITLE.NO_LOCATIONS_FOUND' | translate }}</priva-notification>
        }
    </div>
</app-terminal-overlay>
